var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherLightingProbability = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 31,
  x: 0.5,
  y: 0.5,
  fill: "#2D2D30",
  stroke: "#505051",
  rx: 15.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8D41D",
  d: "M20.877 12.174a.44.44 0 0 1 .078.491L14.93 25.578a.53.53 0 0 1-.47.28c-.044 0-.1-.012-.155-.023-.246-.078-.391-.313-.335-.547l2.198-9.018-4.53 1.127c-.045.011-.09.011-.135.011a.55.55 0 0 1-.346-.122.44.44 0 0 1-.145-.436l2.243-9.207a.496.496 0 0 1 .492-.357h3.66c.28 0 .502.212.502.468a.46.46 0 0 1-.055.201l-1.909 5.168 4.42-1.094a.6.6 0 0 1 .134-.022c.145 0 .279.067.38.167z"
}))));
export default SvgWeatherLightingProbability;